<template>
  <el-row :gutter="config.gutter" style="height：auto">
    <el-col :span="config.span">
      <el-card :shadow="config.shadow" :class="config.borderClass">
        <div class="panel-title">{{ $t(config.name) }}</div>
        <div class="file-radio">
          <span v-if="config.select">
            {{ $t(config.select.label) }}
            <el-select
              style="width: 220px"
              v-model="config.select.value"
              :disabled="config.select.disabled"
              :clearable="config.select.clearable === false ? config.select.clearable : true"
              :filterable="config.select.filterable"
              :placeholder="config.select.placeholder"
              @change="handleEvent(config.select.event, config.select.value)"
            >
              <el-option
                v-for="(childItem, childIndex) in config.select.list"
                :key="childIndex"
                :label="childItem.key"
                :value="childItem.value"
              />
            </el-select>
          </span>
          <span v-if="config.datePicker">
            {{ $t(config.datePicker.label) }}
            <el-date-picker
              v-model="config.datePicker.value"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              :disabled="config.datePicker.disabled"
              align="right"
              :default-value="new Date()"
              :picker-options="pickerOptions"
              @change="handleClick(config.datePicker.orderDateEvent, config.datePicker.value)"
            /> <template v-if="config.input"><span style="color: #C03639">{{ $t(config.input.label) }}</span><el-input style="width: 280px" v-model="config.input.value" :disabled="config.input.disabled"/></template>
          </span>
        </div>
        <!-- 文件上传 -->
        <template v-if="config.type === 'file'">
        </template>
        <template v-else-if="config.type !== 'image'">
          <el-alert :closable="false" :title="$t('excel.tip')" type="success" />
        </template>
        <el-form size="mini" style="margin-top: 15px">
          <el-form-item
            :label="config.type != 'image' ? $t('upload.fileUpload') : ''"
          >
            <el-upload
              ref="upload"
              class="upload-demo"
              :action="config.action"
              :list-type="config.listType"
              :multiple="config.multiple"
              :limit="config.limit"
              :file-list="config.fileList"
              :before-upload="beforeUpload"
              :on-preview="onPreview"
              :on-success="onSuccess"
              :on-remove="onRemove"
              :on-error="onError"
              :accept="config.accept"
              :auto-upload="config.autoUpload"
              :headers="{Authorization: token}"
            >
              <template v-if="config.type == 'image'">
                <!--自定义图片预览-->
                <el-image ref="preImg" style="width: 1px;height: 1px;" src="@/assets/images/logo.png" :preview-src-list="imagePrelist" />

                <i slot="default" class="el-icon-plus" />
                <div slot="file" slot-scope="{ fileItem }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="fileItem.url"
                    alt
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(fileItem)"
                    >
                      <i class="el-icon-zoom-in" />
                    </span>
                    <span
                      v-if="!disabled && fileItem.canRemove != false"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(fileItem)"
                    >
                      <i class="el-icon-delete" />
                    </span>
                  </span>
                </div>
                <div class="el-upload__tip" slot="tip" v-if="config.type != 'image'">
                  {{ $t("image.tip") }}
                </div>
              </template>
              <template v-else-if="config.type == 'file'">
                <el-button
                  slot="trigger"
                  size="small"
                  :disabled="config.disabled"
                  type="primary"
                >{{ $t("upload.chioseFile") }}</el-button
                >
                <el-button
                  style="margin-left: 10px; margin-top: -10px"
                  size="small"
                  type="success"
                  @click="submitUpload"
                  :disabled="config.disabled"
                >{{ $t("upload.send") }}</el-button>
              </template>
              <template v-else>
                <el-button
                  slot="trigger"
                  size="small"
                  :disabled="config.disabled"
                  type="primary"
                  >{{ $t("upload.chioseFile") }}</el-button
                >
                <el-button
                  style="margin-left: 10px; margin-top: -10px"
                  size="small"
                  type="success"
                  @click="submitUpload"
                  :disabled="config.disabled"
                  >{{ $t("upload.send") }}</el-button
                >
                <div
                  @click="handleClick(config.templateEvent)"
                  slot="tip"
                  v-if="config.templateShow != 'show'"
                  class="el-upload__tip"
                >
                  <el-link
                    href="#"
                    type="success"
                    style="color: #06c; font-size: 13px"
                    >{{ $t("upload.downTemplate") }}</el-link
                  >
                </div>
              </template>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
          <image width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    refObj: {
      type: Object,
    },
    //配置参数
    config: {
      type: Object,
      default: () => {
        return {
          gutter: 10,
          span: 24,
          shadow: "never",
          borderClass: "no-border",
          type: "image",
          name: "upload.imgUpload",
          action: "",
          listType: "picture-card",
          multiple: true,
          limit: 1,
          accept: "",
          autoUpload: false,
          disabled: false,
          templateShow: 'hidden',
          customPreview: false, //自定义图片预览
        };
      },
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      submitObj: null,
      token: null,
      imagePrelist: [],
      pickerOptions: {
        disabledDate: (time) => {
          let nowData = new Date()
          nowData = new Date(nowData.setDate(nowData.getDate() - 2))
          return time < nowData
        }
      }
    };
  },
  computed: {},
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.upload);
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.upload);
    this.token = localStorage.getItem('token');
  },
  methods: {
    beforeUpload(file) {
      this.submitObj = this.submitObj || new FormData();
      this.submitObj.append("uploadFile", file);
      return true;
    },
    submitUpload() {
      this.$refs.upload.submit();
      let fileName = this.submitObj.get("uploadFileName");
      const submitObj = this.submitObj;
      this.handleClick(this.config.event, submitObj);
      this.submitObj = new FormData();
    },

    // orderDateEvent(data){
    //   console.log(data,'====orderDateEvent')
    //
    // },

    onSuccess(response, file, fileList) {
      console.log(fileList);
      this.config.fileList = fileList;
    },
    onPreview(file){
      if(this.config.customPreview){
        this.imagePrelist = [file.url];
        this.$nextTick(() => {
          this.$refs.preImg.showViewer = true;
          setTimeout(() =>{
            document.querySelector('.el-image-viewer__wrapper').addEventListener('click', (e) => {
              e.stopPropagation();
            })
          },100)
        })
      } else {
        this.dialogVisible = true;
        this.dialogImageUrl = file.url;
      }
    },
    onRemove(file, fileList) {
      this.config.fileList = fileList;
    },
    onError(err, file, fileList){
      console.log(err);
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {

      this.$emit("handleClick", event, data);
    },
  },
};
</script>
<style scoped>
.no-border {
  border: 0;
}
</style>
<style scoped lang="scss">
.file-radio{
  padding: 5px 10px;
  font-size: 16px;
}

/deep/ .el-image-viewer__close {
  .el-icon-circle-close{
    color:#fff!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue